import { User } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import { getMyFinishedCleaningMissionsTodayQuery } from './get-my-finished-cleaning-missions-today-query';

export const getMyFinishedCleaningMissionsTodayQueryOptions = (user: User, today: Date) =>
  queryOptions({
    queryKey: [
      getMyFinishedCleaningMissionsTodayQuery(user, today).className,
      getMyFinishedCleaningMissionsTodayQuery(user, today).toJSON(),
    ],
    queryFn: () => getMyFinishedCleaningMissionsTodayQuery(user, today).find(),
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
